/**
 * AUTO-GENERATED by scripts/prerender-sample-preview.ts — do not edit.
 * Regenerate: npm run prerender-sample-preview
 * Lint: ignored via eslint.config.mjs globalIgnores.
 *
 * HTML lives in sample-preview-snapshots/<id>.generated.ts (code-split per embed).
 */
import type { SamplePreviewId } from "./sample-preview-registry";

export type SamplePreviewEngineSnapshot = {
  html: string;
  pageCount: number;
  revision: string;
};

export type SamplePreviewSampleSnapshot = {
  markdownHash: string;
  chrome: { pageCount: number; revision: string };
  firefox: { pageCount: number; revision: string };
};

export type SamplePreviewSnapshotManifest = {
  optionsKey: string;
  samples: Record<SamplePreviewId, SamplePreviewSampleSnapshot>;
};

export const samplePreviewSnapshotManifest = {
  optionsKey: "a4\u0001portrait\u0001normal\u0001github\u0001auto\u0001auto\u0001false\u0001inter\u000112\u0001inter\u000112\u0001geist-mono\u000110",
  samples: {
    home: {
    markdownHash: "2d7c8fcc",
    chrome: {
      pageCount: 3,
      revision: "sample-snapshot-3",
    },
    firefox: {
      pageCount: 3,
      revision: "sample-snapshot-3",
    },
  },
    resume: {
    markdownHash: "8ef3b3b0",
    chrome: {
      pageCount: 2,
      revision: "sample-snapshot-2",
    },
    firefox: {
      pageCount: 2,
      revision: "sample-snapshot-2",
    },
  },
    readme: {
    markdownHash: "c9fedf5b",
    chrome: {
      pageCount: 2,
      revision: "sample-snapshot-2",
    },
    firefox: {
      pageCount: 2,
      revision: "sample-snapshot-2",
    },
  },
    chatgpt: {
    markdownHash: "e3ae9aa4",
    chrome: {
      pageCount: 1,
      revision: "sample-snapshot-1",
    },
    firefox: {
      pageCount: 2,
      revision: "sample-snapshot-2",
    },
  },
    gemini: {
    markdownHash: "64f6976f",
    chrome: {
      pageCount: 1,
      revision: "sample-snapshot-1",
    },
    firefox: {
      pageCount: 1,
      revision: "sample-snapshot-1",
    },
  },
    mermaid: {
    markdownHash: "838b277b",
    chrome: {
      pageCount: 1,
      revision: "sample-snapshot-1",
    },
    firefox: {
      pageCount: 1,
      revision: "sample-snapshot-1",
    },
  },
  },
} as const satisfies SamplePreviewSnapshotManifest;
